import React, { useState, useEffect } from 'react';
import { notifyError } from '../../../../../components/loader';
import CustomSelect from '../../../../../components/customSelect';
import * as APIs from "../../../../../pages/registrationPage/apis";
import classes from './styles.module.scss'
import PropTypes from 'prop-types';

const AddNewSchoolByStateModel = ({ onClose, onSubmit }) => {
  const [allDropdown, setAllDropdown] = useState({});
  const [allBlock, setAllBlock] = useState([]);

  const initialState = {
    schoolName: '',
    schoolCode: '',
    registrationNumber: '',
    schoolType: '',
    schoolMedium: '',
    emailId: '',
    mobileNumber: '',
    website: '',
    schoolAddress1: '',
    schoolAddress2: '',
    schoolAddress3: '',
    pinCode: '',
    status: 'Active',
    isNewSchool: 1,
    schoolTypeId: 1,
    districtId: '',
    blockId: '',
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const res = await APIs.getMasterData({ tablesName: ["master_district"] });
      if (res.status) setAllDropdown(res.data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (formData.districtId) {
      const getBlocks = async () => {
        let res = await APIs.getCustoDropdown({
          dropdown_code: "block_master",
          districtId: [formData.districtId],
        });
        if (res.status) setAllBlock(res.data);
      };
      getBlocks();
    } else {
      setAllBlock([]);
    }
  }, [formData.districtId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === 'districtId') {
      setFormData(prev => ({ ...prev, districtId: value, blockId: '' }));
    }
    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.schoolName) newErrors.schoolName = "Required";
    if (!formData.schoolCode) newErrors.schoolCode = "Required";
    if (!formData.districtId) newErrors.districtId = "Required";
    if (!formData.blockId) newErrors.blockId = "Required";
    if (!formData.mobileNumber || formData.mobileNumber.length !== 10) newErrors.mobileNumber = "Invalid Mobile";
    if (!formData.pinCode || formData.pinCode.length !== 6) newErrors.pinCode = "Invalid PIN";
    if (!formData.schoolAddress1) newErrors.schoolAddress1 = "Required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      await onSubmit(formData);
      setFormData(initialState);
      onClose();
      // window.location.replace("/admin/school");
    } else {
      notifyError("Please fill all mandatory fields correctly");
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-[930px] xl:w-[1000px] max-h-[85vh] mt-20 flex flex-col">
        {/* Header */}
        <div className="px-8 py-4 border-b flex justify-between items-center bg-slate-50 rounded-t-2xl">
          <div>
            <h2 className="text-xl font-bold text-slate-800">Add New School </h2>
            <p className="text-xs text-slate-500">Provide complete details to create a new school record</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-red-100 text-red-500 transition-all">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="p-8 overflow-y-auto">
          <div className="grid grid-cols-3 gap-x-6 gap-y-4">

            {/* 1. MANDATORY LOCATION INFO */}
            <div className="col-span-3 border-b pb-1 mb-2 text-blue-700 font-bold text-[14px] tracking-widest uppercase">
              Location & Identification
            </div>

            <div className="flex flex-col">
              <label htmlFor="districtSelect" className="text-[13px] font-bold text-slate-700 mb-1">
                DISTRICT <span className='text-red-500'>*</span>
              </label>
              <CustomSelect
                id="districtSelect"
                options={allDropdown?.masterDistrict}
                placeholder="Select District"
                onChange={(e) => handleSelectChange('districtId', e.target.value)}
                name="districtId"
                optionLabel="name"
                optionValue="id"
                second_className={classes.select_custom_width}
                value={formData.districtId}
              />
              {errors.districtId && <span className="text-red-500 text-[9px] font-bold">{errors.districtId}</span>}
            </div>

            <div className="flex flex-col">
              <label htmlFor="blockSelect" className="text-[13px] font-bold text-slate-700 mb-1">
                BLOCK <span className='text-red-500'>*</span>
              </label>
              <CustomSelect
                id="blockSelect"
                options={allBlock}
                placeholder="Select Block"
                onChange={(e) => handleSelectChange('blockId', e.target.value)}
                name="blockId"
                optionLabel="blockName"
                optionValue="blockId"
                value={formData.blockId}
                disabled={!formData.districtId}
              />
              {errors.blockId && <span className="text-red-500 text-[9px] font-bold">{errors.blockId}</span>}
            </div>

            <div className="flex flex-col">
              <label htmlFor="schoolCodeInput" className="text-[13px] font-bold text-slate-700 mb-1">
                SCHOOL CODE <span className='text-red-500'>*</span>
              </label>
              <input
                id="schoolCodeInput"
                name="schoolCode"
                value={formData.schoolCode}
                onChange={handleChange}
                className="border p-2 rounded text-sm outline-none focus:border-blue-400"
                placeholder="e.g. SCH2024001"
              />
              {errors.schoolCode && <span className="text-red-500 text-[9px] font-bold">{errors.schoolCode}</span>}
            </div>

            {/* 2. SCHOOL CORE DETAILS */}
            <div className="col-span-3 border-b pb-1 mt-2 mb-2 text-blue-600 font-bold text-[14px] tracking-widest uppercase">
              School Core Details
            </div>

            <div className="col-span-2 flex flex-col">
              <label htmlFor="schoolNameInput" className="text-[13px] font-bold text-slate-700 mb-1">SCHOOL NAME <span className='text-red-500'>*</span></label>
              <input id="schoolNameInput" name="schoolName" value={formData.schoolName} onChange={handleChange} className="border p-2 rounded outline-none focus:border-blue-400" placeholder="Government Primary School" />
              {errors.schoolName && <span className="text-red-500 text-[9px] font-bold">{errors.schoolName}</span>}
            </div>

            <div className="flex flex-col">
              <label htmlFor="regNoInput" className="text-[13px] font-bold text-slate-700 mb-1">REGISTRATION NO.</label>
              <input id="regNoInput" name="registrationNumber" value={formData.registrationNumber} onChange={handleChange} className="border p-2 rounded outline-none" placeholder="REG2024001" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="schoolTypeSelect" className="text-[13px] font-bold text-slate-700 mb-1">SCHOOL TYPE</label>
              <select id="schoolTypeSelect" name="schoolType" value={formData.schoolType} onChange={handleChange} className="border p-2 rounded bg-white">
                <option value="">Select Type</option>
                <option value="Co-Educational">Co-Educational</option>
                <option value="Boys School">Boys School</option>
                <option value="Girls School">Girls School</option>
              </select>
            </div>

            <div className="flex flex-col">
              <label htmlFor="mediumSelect" className="text-[13px] font-bold text-slate-700 mb-1">MEDIUM</label>
              <select id="mediumSelect" name="schoolMedium" value={formData.schoolMedium} onChange={handleChange} className="border p-2 rounded bg-white">
                <option value="">Select Medium</option>
                <option value="Hindi">Hindi</option>
                <option value="English">English</option>
                <option value="Both">Both Hindi & English</option>
              </select>
            </div>

            <div className="flex flex-col">
              <label htmlFor="statusSelect" className="text-[13px] font-bold text-slate-700 mb-1">STATUS</label>
              <select id="statusSelect" name="status" value={formData.status} onChange={handleChange} className="border p-2 rounded bg-white">
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>

            {/* 3. CONTACT & WEB */}
            <div className="col-span-3 border-b pb-1 mt-2 mb-2 text-blue-600 font-bold text-[14px] tracking-widest uppercase">
              Contact & Digital Info
            </div>

            <div className="flex flex-col">
              <label htmlFor="mobileInput" className="text-[13px] font-bold text-slate-700 mb-1">MOBILE NUMBER <span className='text-red-500'>*</span></label>
              <input id="mobileInput" name="mobileNumber" maxLength={10} value={formData.mobileNumber} onChange={handleChange} className="border p-2 rounded text-sm" placeholder="9876543210" />
              {errors.mobileNumber && <span className="text-red-500 text-[9px] font-bold">{errors.mobileNumber}</span>}
            </div>

            <div className="flex flex-col">
              <label htmlFor="emailInput" className="text-[13px] font-bold text-slate-700 mb-1">EMAIL ID</label>
              <input id="emailInput" name="emailId" type="email" value={formData.emailId} onChange={handleChange} className="border p-2 rounded text-sm" placeholder="school@example.com" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="websiteInput" className="text-[13px] font-bold text-slate-700 mb-1">WEBSITE</label>
              <input id="websiteInput" name="website" value={formData.website} onChange={handleChange} className="border p-2 rounded" placeholder="https://school.com" />
            </div>

            {/* 4. ADDRESS DETAILS */}
            <div className="col-span-3 border-b pb-1 mt-2 mb-2 text-blue-600 font-bold text-[14px] tracking-widest uppercase">
              Address Details
            </div>

            <div className="flex flex-col">
              <label htmlFor="address1Input" className="text-[13px] font-bold text-slate-700 mb-1">ADDRESS LINE 1 <span className='text-red-500'>*</span></label>
              <input id="address1Input" name="schoolAddress1" value={formData.schoolAddress1} onChange={handleChange} className="border p-2 rounded text-sm" placeholder="123 Main Road" />
              {errors.schoolAddress1 && <span className="text-red-500 text-[9px] font-bold">{errors.schoolAddress1}</span>}
            </div>

            <div className="flex flex-col">
              <label htmlFor="address2Input" className="text-[13px] font-bold text-slate-700 mb-1">ADDRESS LINE 2</label>
              <input id="address2Input" name="schoolAddress2" value={formData.schoolAddress2} onChange={handleChange} className="border p-2 rounded text-sm" placeholder="Near Bus Stand" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="address3Input" className="text-[13px] font-bold text-slate-700 mb-1">ADDRESS LINE 3</label>
              <input id="address3Input" name="schoolAddress3" value={formData.schoolAddress3} onChange={handleChange} className="border p-2 rounded text-sm" placeholder="Landmark" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="pinCodeInput" className="text-[13px] font-bold text-slate-700 mb-1">PIN CODE <span className='text-red-500'>*</span></label>
              <input id="pinCodeInput" name="pinCode" maxLength={6} value={formData.pinCode} onChange={handleChange} className="border p-2 rounded text-sm" placeholder="800001" />
              {errors.pinCode && <span className="text-red-500 text-[9px] font-bold">{errors.pinCode}</span>}
            </div>
          </div>

          <div className="flex justify-end gap-3 mt-8 pt-6 border-t">
            <button type="button" onClick={onClose} className="px-6 py-2 rounded-lg font-bold bg-slate-200 text-slate-700 hover:bg-slate-300 transition-all">
              Cancel
            </button>
            <button type="submit" className="px-10 py-2 rounded-lg font-bold bg-blue-600 text-white hover:bg-blue-700 shadow-md transition-all">
              Create School
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

AddNewSchoolByStateModel.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AddNewSchoolByStateModel;